import type { ReactNode } from "react";

export default function DropdownItem({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) {
  return (
    <li
      className="px-0.5 hover:bg-[#ffffff10] rounded-none py-0.5 cursor-pointer items-center text-accent-content"
      {...(onClick ? { onClick } : {})}
    >
      <div className="flex flex-nowrap w-full rounded-none whitespace-nowrap">
        {children}
      </div>
    </li>
  );
}
